import React from "react";
import { Dropdown } from "antd";

import { useDispatch } from "react-redux";

import { downloadRequest } from "../../store/actions/deviceProfile";

const DeviceProfileDropdown = () => {
  
  const dispatch = useDispatch();

  const handleExport = () => {
    dispatch(
      downloadRequest()
    );
  };

  
  const items = [
    {
      label: <span className="font-face-vzw">Actions</span>,
      key: `device-profile-actions`,
    },
    {
      label: (
        <button onClick={() => handleExport()} className="ats-text-btn">
          Export
        </button>
      ),
      key: `device-profile-export`,
    }
  ];

  return (
      <Dropdown
        key={`dropdown-device-profile-all`}
        menu={{
          items,
        }}
        trigger={["click"]}
        overlayClassName="shipment-dropdown-overlay"
      >
        <button className="btn btn-link text-secondary">
          <i className="bi-three-dots-vertical fs-6" />
        </button>
      </Dropdown>
  );
};

export default DeviceProfileDropdown;
